import { useCallback, useState } from "react"
import { r2ImageUrl } from "~shared/r2"

const SIZES = {
	xs: "h-7 w-7",
	sm: "h-9 w-9",
	md: "h-10 w-10",
	xl: "h-20 w-20",
}

const TEXT_SIZES = {
	xs: "text-xs",
	sm: "text-xs",
	md: "text-sm",
	xl: "text-2xl",
}

const DISPLAY_SIZES = {
	xs: 28,
	sm: 36,
	md: 40,
	xl: 80,
}

const IMAGE_WIDTHS: Record<string, number> = {
	xs: 56,
	sm: 72,
	md: 96,
	xl: 192,
}

interface AvatarProps {
	alt: string
	fallback: string
	size?: "xs" | "sm" | "md" | "xl"
	style?: React.CSSProperties
	url?: string
}

export function Avatar({ alt, fallback, size = "md", style, url }: AvatarProps) {
	const sizeClass = SIZES[size]
	const [imgError, setImgError] = useState(false)
	const handleError = useCallback(() => setImgError(true), [])

	if (url && !imgError) {
		return (
			<img
				alt={alt}
				className={`${sizeClass} rounded-full object-cover`}
				decoding="async"
				height={DISPLAY_SIZES[size]}
				loading="lazy"
				onError={handleError}
				src={r2ImageUrl(url, { width: IMAGE_WIDTHS[size] })}
				style={style}
				width={DISPLAY_SIZES[size]}
			/>
		)
	}
	return (
		<div
			className={`flex ${sizeClass} items-center justify-center rounded-full bg-app-surface-elevated font-bold text-app-text-secondary ${TEXT_SIZES[size]}`}
			style={style}
		>
			{fallback}
		</div>
	)
}
